import React from "react";
import PropTypes from 'prop-types';

import { MaterialIcons, MaterialCommunityIcons } from "@expo/vector-icons"
import { Icon as NBIcon } from "native-base"
import get from "lodash/get";

const availableIconFamilies = {
    "material": MaterialIcons,
    "material-community": MaterialCommunityIcons
}

const getIconFamily = (familyName)  => get(availableIconFamilies, familyName, MaterialIcons);
export class Icon extends React.Component {
    static propTypes = {
        type: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.node,
        ]),
        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.node
        ]),
        iconFamily: PropTypes.string,
    }

    static defaultProps = {
        type: null,
        value: null,
    }

    render() {
        const { value, type, onClick, iconFamily, ...otherProps } = this.props
        const icon = value || type;

        return icon
            ? typeof icon === "string"
                ? <NBIcon as={ getIconFamily(iconFamily) } name={icon} { ...otherProps } />
                : icon
            : icon
    }
}